import { c as _c } from "react/compiler-runtime";
/**
 * Breadcrumbs Component
 *
 * Displays navigation breadcrumbs.
 *
 * Variants:
 * - default: blue links on light background (industry / CMS pages)
 * - dark: white links + orange arrows on dark hero background
 *
 * @example
 * <Breadcrumbs
 *   items={[
 *     { label: "Home", href: "/" },
 *     { label: "Manufacturing" },
 *   ]}
 * />
 */

import { cn } from '@/lib/utils';
import styles from './Breadcrumbs.module.css';
export interface BreadcrumbItem {
  /** Display label */
  label: string;
  /** Link URL (omit for current page) */
  href?: string;
}
export interface BreadcrumbsProps {
  /** Array of breadcrumb items */
  items: BreadcrumbItem[];
  /** Stable CMS block id for content verification and agent editing */
  blockId?: string;
  /** Additional CSS classes */
  className?: string;
  /** Visual variant for different backgrounds */
  variant?: 'default' | 'dark';
  /** Page wraps the list in the shared container; inline uses the parent layout. */
  layout?: 'page' | 'inline';
}
export function Breadcrumbs(t0) {
  const $ = _c(14);
  const {
    items,
    blockId,
    className,
    variant: t1,
    layout: t2
  } = t0;
  const variant = t1 === undefined ? "default" : t1;
  const layout = t2 === undefined ? "page" : t2;
  let t3;
  if ($[0] !== items) {
    t3 = items.map(_temp);
    $[0] = items;
    $[1] = t3;
  } else {
    t3 = $[1];
  }
  let t4;
  if ($[2] !== t3) {
    t4 = <ol className={styles.list}>{t3}</ol>;
    $[2] = t3;
    $[3] = t4;
  } else {
    t4 = $[3];
  }
  const list = t4;
  const t5 = variant === "dark" && styles.dark;
  let t6;
  if ($[4] !== className || $[5] !== t5) {
    t6 = cn(styles.breadcrumbs, t5, className);
    $[4] = className;
    $[5] = t5;
    $[6] = t6;
  } else {
    t6 = $[6];
  }
  let t7;
  if ($[7] !== layout || $[8] !== list) {
    t7 = layout === "page" ? <div className="page-container">{list}</div> : list;
    $[7] = layout;
    $[8] = list;
    $[9] = t7;
  } else {
    t7 = $[9];
  }
  let t8;
  if ($[10] !== blockId || $[11] !== t6 || $[12] !== t7) {
    t8 = <nav aria-label="Breadcrumb" className={t6} data-cms-block-id={blockId}>{t7}</nav>;
    $[10] = blockId;
    $[11] = t6;
    $[12] = t7;
    $[13] = t8;
  } else {
    t8 = $[13];
  }
  return t8;
}
function _temp(item, index) {
  return <li key={`${item.label}-${index}`} className={styles.item}>{index > 0 && <span className={styles.separator} data-breadcrumb-separator={true}>›</span>}{item.href ? <a href={item.href} className={styles.link}>{item.label}</a> : <span className={styles.current}>{item.label}</span>}</li>;
}